import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

export const GroupedMenuBodyRight = (props) => {
	const {
		className,
		children
	} = props;

	return (
		<div className={classNames(className, 'ads-grouped-menu-body-right')}>{children}</div>
	);
}

GroupedMenuBodyRight.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
};

GroupedMenuBodyRight.defaultProps = {
	className: '',
};
